import { Component, OnInit, Input, ComponentRef, ViewChild, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { AgentscriptService } from '../services/agentscript-services/agentscript.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
//import * as moment from 'moment';
declare var $ : any;
import { StandardUIService } from '../services/standardui-service/standardui-service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
// import { MultiSelectComponent } from '@syncfusion/ej2-angular-dropdowns';
import { FormBuilder, FormGroup, Validators, FormControl, FormsModule, ReactiveFormsModule, FormArray } from '@angular/forms';
import { TrackingLog } from '../services/Trackinglog-service/trackinglog.service';
import { LocalStorageService } from '../services/localstorage-service/localstorage-service';
//var ch = require('../../assets/vendor/js/chosen.js');

@Component({
  selector: 'app-tracking-view',
  templateUrl: './tracking-view.component.html',
  styleUrls: ['./tracking-view.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TrackingViewComponent implements OnInit {
  @Input() context;


  
  constructor(
    private agentScriptService:AgentscriptService,
    private modalService: NgbModal,
    private standardUIService:StandardUIService,
    private trackingLog:TrackingLog,
    private formBuilder: FormBuilder,
    private localStorageService :LocalStorageService
    ) { }
  
  @ViewChild('reportPopupForm') public reportPopupForm;
  private cmpRef: ComponentRef<any>;
  showForm:boolean = false;
  public checkFields: Object = { text: 'valueen', value: 'id' };
  public checkWaterMark: string = ''; 
  public popHeight: string = '350px';
  public mode = 'CheckBox';
  public filterPlaceholder = 'Search';
  
  trackingLogForm: FormGroup;
  submitted = false;
  loading = false;
  allTrackingLog:any = [];
  contactTypes:any = [];
  contactCategories:any = [];
  programme:any = [];
  dropdownSettings:any = {};
  programId;
  loggedName:any;
  @Output() componentSelection = new EventEmitter<any>();
  ngOnInit() {
    if(this.context.id){
      this.trackingLog.getTrackingLog(this.context.id).subscribe(data=>{
        this.allTrackingLog = data;
        //console.log(this.allTrackingLog);
      });
      // this.loggedName = JSON.parse(this.localStorageService.get('currentUser')).firstname+' '+JSON.parse(this.localStorageService.get('currentUser')).lastname;      
     this.loggedName="John";
    }
    this.dropdownSettings = {
      text: "",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      classes: "col-md-8",
      enableSearchFilter: true,
      //badgeShowLimit: 3
  }
    this.trackingLog.getPiclistValues(94).subscribe(data=>{
      this.contactCategories = data;
    });
    this.trackingLog.getPiclistValues(28).subscribe(data=>{
      this.contactTypes = data;
    });
    this.trackingLog.getPiclistValues(193).subscribe(data=>{
      this.programme = data;
    });
    this.trackingLogForm = this.formBuilder.group({
      //createdtime: [''],
      id:'',
      contactcategory:[[],Validators.required],
      othercategory:'',
      contactdate:['',Validators.required],
      contacttype:['',Validators.required],
      program:['',Validators.required],
      note:['',Validators.required]
    })
   
  }
  ngAfterViewInit(){
      // let self = this;
      // $(document).on("change",".multiselect",function(){
      //   console.log($(this).val());
      //   self.trackingLogForm.controls[$(this).attr('formcontrolname')].setValue($(this).val());
      // })    
  }
  convertDate(data){
    return this.standardUIService.getDate(data);
  }
  get trackingLogFormData() { return this.trackingLogForm.controls; }
  showTrackingForm(){
    Swal.fire({
      title: 'You are going to add a new log.',
      text: 'Are you sure?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        
        //this.contactcat.selectAll(true); 
        this.showForm = true;
        // setTimeout(()=>{
        //   $(".multiselect").chosen().trigger('chosen:updated');
        // },500);
      }
    });   
  }
  back(){
    this.showForm = false;
    this.ngOnInit();
  }
  getPiclistArrayName(item){
    if(item.length > 0){
      return this.standardUIService.convertArrayForPicklistToName(item);
    }
  }
  getProgramName(id){    
    for(let pg in this.programme){
       if(this.programme[pg].id == id){
         return this.programme[pg].valueen;
       }
    }
  }
  onTrackingLogFormSubmit(){
    console.log(this.trackingLogForm.value);
    this.submitted = true;
    if (this.trackingLogForm.invalid) {
      return;
    }
    let payload = this.getPayload();
    console.log(payload);
    this.trackingLog.saveTrackingLog(payload).subscribe((data)=>{
        console.log(data);
        if(data.error){
          Swal.fire('Oops...!', data.error, 'error');
        } else {
          this.submitted = false;
          this.trackingLogForm.reset();
          Swal.fire('Success!', 'Saved successfully!', 'success');
          this.back();
        }        
    })
    
  }
  
  editTrackingLog(item){
    console.log(item);
    this.showForm = true;   
    
    this.trackingLogForm.patchValue({
      id:item.id,
      contactcategory : item.contactcategories,
      othercategory:'',
      contactdate:this.standardUIService.getDateByFormat(item.contactdate,'-','ymd'),
      contacttype:item.contacttypes,
      program:item.program,
      note:item.note
    })   
  }
  
  getPayload(){
    let tempPayload:any;
    if(this.trackingLogFormData.id.value){
      tempPayload = {
        "entityName":"Trackinglog",
        "payLoad":{
        "id":this.trackingLogFormData.id.value,
        "personid":{"id":this.context.id},
        "note":(this.trackingLogFormData.note.value) ? this.trackingLogFormData.note.value : '',
        "contactdate":(this.trackingLogFormData.contactdate.value) ? this.standardUIService.getTimeStampDate(this.trackingLogFormData.contactdate.value) : '',
        "contacttypes":(this.trackingLogFormData.contacttype.value) ? this.standardUIService.convertArrayForPicklist(this.trackingLogFormData.contacttype.value) : '',
        "contactcategories":(this.trackingLogFormData.contactcategory.value) ? this.standardUIService.convertArrayForPicklist(this.trackingLogFormData.contactcategory.value) : '',
        "program":(this.trackingLogFormData.program.value) ? this.trackingLogFormData.program.value : ''
        }
      }
    }else{
      tempPayload = {
        "entityName":"Trackinglog",
        "payLoad":{
        "personid":{"id":this.context.id},
        "note":(this.trackingLogFormData.note.value) ? this.trackingLogFormData.note.value : '',
        "contactdate":(this.trackingLogFormData.contactdate.value) ? this.standardUIService.getTimeStampDate(this.trackingLogFormData.contactdate.value) : '',
        "contacttypes":(this.trackingLogFormData.contacttype.value) ? this.standardUIService.convertArrayForPicklist(this.trackingLogFormData.contacttype.value) : '',
        "contactcategories":(this.trackingLogFormData.contactcategory.value) ? this.standardUIService.convertArrayForPicklist(this.trackingLogFormData.contactcategory.value) : '',
        "program":(this.trackingLogFormData.program.value) ? this.trackingLogFormData.program.value : ''
        }
      }
    }
    
    return tempPayload;
  }

  public componentSelectionEmitter(componentData: object) {
    console.log(componentData);
    this.componentSelection.emit(componentData);
  }
  ngOnDestroy() {
    if(this.cmpRef) {
        this.cmpRef.destroy();
    }
  }

}
